<template>
  <table  class="table table-hover">
    <tbody>
      <tr>
        <td>
          <div class="text-info font-weight-bold">{{$t('admin.settings.job1')}}</div>
          <div class="text-info  font-weight-light">{{ $t('admin.settings.description1') }}</div>
        </td>
        <td>
          <b-button variant="outline-info" class="float-right"  @click="markJob">{{ $t('admin.settings.jobs.run') }}</b-button>
        </td>
      </tr>
    </tbody>

  </table>


</template>

<script>
import i18n from "@/i18n.bootstrap";

export default {
  name: "tab-Jobs",
  methods: {
    markJob() {
      this.$snotify.confirm(i18n.t('general.promptQuestion'), '', {
        closeOnClick: true,
        backdrop: 0.3,
        buttons: [
          { text: i18n.t('general.yes'), action: this.markJobAction },
          { text: i18n.t('general.no') }
        ]
      });
    },

    markJobAction(){
      this.$store.dispatch('system/markJob');
    }
  }
}

</script>

<style scoped>

</style>